import {ReactElement} from 'react';
import {Link} from '@shopify/hydrogen';
import type {StateType} from '../../types';

import {getWhiskyBars} from '../../backendApi';
import {useQuery as useBackendQuery} from 'react-query';
import WhiskyBarCard from './whisky-bars/WhiskyBarCard.client';

interface MoreWhiskyBarsProps {
  state: StateType;
}

export default function MoreWhiskyBars({
  state,
}: MoreWhiskyBarsProps): ReactElement {
  const {
    data: whiskyBarsPage,
    isLoading: whiskyBarsIsLoading,
    error: whiskyBarsError,
  } = useBackendQuery(['getFourWhiskyBars', state.slug], () =>
    getWhiskyBars({stateSlug: state.slug, pageSize: 4, order: '?'}),
  );

  return (
    <section>
      <div className="more-whisky-bars bg-gray">
        <div className="container">
          <h3 className="title-1">
            Discover More Whisky Bars &amp; Venues in {state.name}
          </h3>
          <div className="list-type-3 bars-list image-hover" id="bars-list">
            {!whiskyBarsError && (
              <>
                {whiskyBarsIsLoading ? (
                  <>
                    <WhiskyBarCard />
                    <WhiskyBarCard />
                    <WhiskyBarCard />
                    <WhiskyBarCard />
                  </>
                ) : (
                  whiskyBarsPage.results.map((whiskyBar) => (
                    <WhiskyBarCard key={whiskyBar.uuid} whiskyBar={whiskyBar} />
                  ))
                )}
              </>
            )}
          </div>
          <div className="list-type-2__more">
            <Link to={`/bars/states/${state.slug}/`} className="button">
              All {state.name} Whisky Bars
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
